/* global axios */
import ApiClient from './ApiClient';

class ConversationFunnelMappingsAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/funnel_mappings`;
  }

  // Buscar todos os mapeamentos de uma conversa
  getMappings(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  // Adicionar conversa a um funil
  addToFunnel(conversationId, funnelId, stageName = null) {
    return axios.post(this.getUrl(conversationId), {
      funnel_id: funnelId,
      stage_name: stageName,
    });
  }

  // Atualizar mapeamento (mudar funil ou etapa)
  updateMapping(conversationId, mappingId, data) {
    return axios.patch(`${this.getUrl(conversationId)}/${mappingId}`, data);
  }

  // Remover conversa de um funil
  removeFromFunnel(conversationId, mappingId) {
    return axios.delete(`${this.getUrl(conversationId)}/${mappingId}`);
  }

  // Mover conversa para outra etapa
  moveToStage(conversationId, mappingId, stageName) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/move_stage`,
      {
        stage_name: stageName,
      }
    );
  }

  // Buscar conversas por funil e etapa (para kanban)
  getConversationsByFunnelAndStage(funnelId, stageName = null) {
    const params = { funnel_id: funnelId };
    if (stageName) {
      params.stage_name = stageName;
    }
    return axios.get(`${this.url}/filter`, { params });
  }

  // === NOVOS MÉTODOS PARA CHECKLIST ===

  // Adicionar item ao checklist
  addChecklistItem(conversationId, mappingId, text, agentId = null) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/add_checklist_item`,
      {
        text,
        agent_id: agentId,
      }
    );
  }

  // Atualizar item do checklist
  updateChecklistItem(conversationId, mappingId, itemId, updates) {
    return axios.patch(
      `${this.getUrl(conversationId)}/${mappingId}/update_checklist_item`,
      {
        item_id: itemId,
        ...updates,
      }
    );
  }

  // Toggle item do checklist (marcar/desmarcar como concluído)
  toggleChecklistItem(conversationId, mappingId, itemId, done) {
    return this.updateChecklistItem(conversationId, mappingId, itemId, {
      done,
    });
  }

  // Remover item do checklist
  removeChecklistItem(conversationId, mappingId, itemId) {
    return axios.delete(
      `${this.getUrl(conversationId)}/${mappingId}/remove_checklist_item`,
      {
        data: { item_id: itemId },
      }
    );
  }

  // === NOVOS MÉTODOS PARA MULTI-AGENTES ===

  // Atribuir agente ao mapping
  assignAgent(conversationId, mappingId, agentId, role = 'secondary') {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/assign_agent`,
      {
        agent_id: agentId,
        role,
      }
    );
  }

  // Remover agente do mapping
  removeAgent(conversationId, mappingId, agentId) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/remove_agent`,
      {
        agent_id: agentId,
      }
    );
  }

  // === NOVOS MÉTODOS PARA TIMER ===

  // Iniciar timer
  startTimer(conversationId, mappingId) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/start_timer`
    );
  }

  // Pausar timer
  pauseTimer(conversationId, mappingId) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/pause_timer`
    );
  }

  // Resetar timer
  resetTimer(conversationId, mappingId) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/reset_timer`
    );
  }

  // === MÉTODO DE BATCH UPDATE PARA PERFORMANCE ===

  // Atualizar múltiplos campos de uma vez
  batchUpdateMapping(conversationId, mappingId, updates) {
    return axios.patch(`${this.getUrl(conversationId)}/${mappingId}`, updates);
  }

  // === MÉTODOS PARA DEAL MANAGEMENT ===

  // Atualizar dados do deal
  updateDeal(conversationId, mappingId, dealData) {
    return axios.patch(
      `${this.getUrl(conversationId)}/${mappingId}/update_deal`,
      dealData
    );
  }

  // Marcar deal como ganho
  markAsWon(conversationId, mappingId, reason = null) {
    return axios.post(`${this.getUrl(conversationId)}/${mappingId}/mark_won`, {
      reason,
    });
  }

  // Marcar deal como perdido
  markAsLost(conversationId, mappingId, reason = null) {
    return axios.post(`${this.getUrl(conversationId)}/${mappingId}/mark_lost`, {
      reason,
    });
  }

  // Reabrir deal
  reopenDeal(conversationId, mappingId) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/reopen_deal`
    );
  }

  // === MÉTODOS PARA FUNNEL ACTIVITIES (TIMELINE) ===

  // Buscar atividades de um mapping
  getActivities(conversationId, mappingId, params = {}) {
    return axios.get(
      `${this.getUrl(conversationId)}/${mappingId}/funnel_activities`,
      { params }
    );
  }

  // Adicionar nota ao timeline
  addNote(conversationId, mappingId, content) {
    return axios.post(
      `${this.getUrl(conversationId)}/${mappingId}/funnel_activities`,
      {
        activity_type: 'note_added',
        content,
      }
    );
  }
}

export default new ConversationFunnelMappingsAPI();
